import React from "react";
var __jsx = React.createElement;
import { MultiSelect } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FILTER_SELECT_STYLES } from "./filter-control-styles";
import { FilterOptionItem } from "./filter-option-item";
var CHECK_ITEM_STYLE = {
  color: "var(--sds-text-base-default)",
  "&[data-hovered]": {
    backgroundColor: "var(--sds-bg-base-secondary)"
  },
  "&[data-selected]": {
    "&, &:hover": {
      backgroundColor: "transparent",
      color: "var(--sds-text-base-default)"
    },
    "&[data-hovered]": {
      backgroundColor: "var(--sds-bg-base-secondary)"
    }
  }
};

/** Mantine multi-select filter (chooses several values). */
export function MultiSelectFilter(_ref) {
  var label = _ref.label,
    options = _ref.options,
    selected = _ref.selected,
    onChange = _ref.onChange,
    testId = _ref.testId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var safeOptions = options.filter(function (option) {
    return option.value && option.label;
  });
  var matchByLabel = function matchByLabel(query, _selected, item) {
    var _item$label;
    return String((_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : "").toLowerCase().trim().includes(query.toLowerCase().trim());
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-52"
  }, /*#__PURE__*/React.createElement(MultiSelect, {
    size: "sm",
    placeholder: label,
    data: safeOptions,
    value: selected,
    onChange: onChange,
    nothingFound: t("no_options", {
      defaultValue: "No options"
    }),
    searchable: true,
    clearable: true,
    withinPortal: true,
    disableSelectedItemFiltering: true,
    filter: matchByLabel,
    itemComponent: FilterOptionItem,
    "data-testid": testId,
    styles: {
      input: FILTER_SELECT_STYLES.input,
      dropdown: FILTER_SELECT_STYLES.dropdown,
      item: CHECK_ITEM_STYLE,
      values: {
        flexWrap: "nowrap",
        overflow: "hidden"
      },
      value: {
        flexShrink: 0
      },
      searchInput: {
        minWidth: 0
      }
    }
  }));
}